import { Toolbar } from "../../components/ui/toolbar/toolbar.component";

export const JobServiceListActions = () => {
  return <Toolbar actions={[]} />;
};
